module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - jinsilhanja.a358b2c8.pdf";